import React, { useCallback, useEffect, useRef, useState } from "react";
import Button from "@UI/kit/Button/Button";
import Success from "@Images/payments/Success.png";
import { useNavigate, useParams } from "react-router-dom";
import { getLandingReceipt } from "@API/axiosRequest";
import { currencySymbols } from "@Static/static";
import { sendLandingLetter } from "@API/axiosRequest";
import dayjs from "dayjs";
import "dayjs/locale/ru";
import "dayjs/locale/kk";
import { useTranslation } from "react-i18next";
import FormContainer from "@UI/kit/FormContainer/FormContainer";

const NightPassSuccess = () => {
  const { receiptId } = useParams();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [receipt, setReceipt] = useState();
  const [parking, setParking] = useState({});
  const [email, setEmail] = useState("");
  const [plateNumber, setPlateNumber] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const initialLoad = useRef(true);

  const formatDate = (dateString) => {
    dayjs.locale(i18n.language);
    return dayjs(dateString).format("D MMMM YYYY, HH:mm");
  };

  const sendLetter = useCallback(
    async (userEmail, parkingName, parkingAddress, plateNumber, dateStart, dateEnd, sum, currency) => {
      sendLandingLetter(userEmail, parkingName, parkingAddress, plateNumber, dateStart, dateEnd, sum, currency);
    },
    [],
  );

  useEffect(() => {
    if (initialLoad.current) {
      setIsLoading(true);
      getLandingReceipt(receiptId)
        .then((res) => {
          const receipt = res?.data;
          setReceipt(receipt.abonement);

          sendLetter(
            res.data?.email,
            receipt.abonement?.parking.address,
            receipt.abonement?.parking.name,
            receipt.abonement?.plateNumber,
            receipt.abonement?.begin,
            receipt.abonement?.end,
            receipt.abonement?.price,
            currencySymbols[receipt.abonement?.parking.currency],
          );
        })
        .catch(() => {
          // navigate('/parking/night-pass/error');
        })
        .finally(() => setIsLoading(false));

      setParking(parking);
      setEmail(email);
      setPlateNumber(plateNumber);
    }
    initialLoad.current = false;
  }, []);

  return (
    <div>
      <FormContainer withApps={true} withAppDescription={true}>
        <div className="relative flex flex-col items-center">
          <img src={Success} alt="Error" className="mb-6" />
          <div className="mb-6 flex flex-col space-y-1">
            <p className="text-center text-2xl font-medium text-surface">{t("payment_was_successful")}</p>
            <p className="text-center text-base text-textNormal">
              {t("we_have_sent_receipt_to_email")}
              <br /> {email}
            </p>
          </div>
          <div className="mb-6 flex w-full flex-col space-y-2">
            <p className="font-bold text-textLoud">{receipt?.typeDefinition}</p>
            <p className="text-textLoud">{t("night_pass_time")}</p>
            <p className="text-sm text-textNormal">{t("night_pass_description")}</p>
          </div>
          {parking && (
            <div className="mb-6 w-full">
              <p className="text-textMuted">{receipt?.parking.name}</p>
              <p className="text-sm text-textNormal">{receipt?.parking?.address}</p>
            </div>
          )}
          {receipt && (
            <>
              <div className="mb-4 flex w-full flex-col space-y-2">
                <div className="flex items-center justify-between">
                  <p className="text-sm text-textNormal">{t("car_number")}</p>
                  <p className="text-sm text-textMuted">{receipt?.plateNumber}</p>
                </div>
                <div className="flex items-center justify-between">
                  <p className="text-sm text-textNormal">{t("start_date")}</p>
                  <p className="text-sm text-textMuted">{formatDate(receipt?.begin)}</p>
                </div>
                <div className="flex items-center justify-between">
                  <p className="text-sm text-textNormal">{t("end_date")}</p>
                  <p className="text-sm text-textMuted">{formatDate(receipt?.end)}</p>
                </div>
              </div>
              <div className="mb-6 flex w-full justify-between">
                <p className="text-lg">{t("total_cost")}</p>
                <p className="text-lg">
                  {receipt?.price} {currencySymbols[receipt?.parking?.currency]}
                </p>
              </div>
            </>
          )}

          <Button
            text={t("close")}
            styles="bg-[#F2F4F7] hover:bg-disabled"
            textStyles="text-link"
            onClick={() => navigate("/parking/night-pass")}
          />
        </div>
      </FormContainer>
    </div>
  );
};

export default NightPassSuccess;
